import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export const usePayoutInvoices = (payoutId, param)=>{
    let { enabled } = param;
    const { api } = useStoreActions();
    return useQueryState({
        queryKey: [
            QueryKeys.PayoutInvoices,
            payoutId
        ],
        queryFn: ()=>api.payout.getPayoutInvoices(payoutId),
        enabled
    });
};
